import React from 'react';

import *  as S from './Footer.styles';
import arrowFooter from '../../assets/Arrow-footer.png'

const Footer = () => {
  const gotoTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
  return (
    <S.Ftr>
      <S.FtrWrapper>
        <S.FtrBtnArrow onClick={gotoTop}><img src={arrowFooter} alt="" /></S.FtrBtnArrow>
      </S.FtrWrapper>
    </S.Ftr>
  )
}

export default Footer;